import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'

export default class LopiGrid extends Component {
    componentDidMount() {
        /*console.log(this.props.products.hits)*/
    }

    componentDidUpdate() {
        /*console.log(this.props.products.hits)*/
    }

    render() {

        return (    
            <Container>
                <Row>
                    <Col>
                        <p>{this.props.products.found} items</p>
                    </Col>
                </Row>
                <Row className="LopiGridContainer row-flex">
                    {this.props.products.hits && this.props.products.hits.map(product => (
                        <Col md="4" sm="6" lg="3" key={product.id} className="LopiGridCol">
                            <a href={product.link}>
                                <Card>
                                    <div className="LopiGridImageWrapper">
                                        <Card.Img className="LopiGridImage" variant="top" src={product.image} />
                                    </div>
                                    <Card.Body style={{width:"100%", height:"100%"}}> 
                                        <Card.Title as="h6">{product.title}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>
                    ))}
                </Row>               
            </Container>
        )
    }
}